import { useSchedules } from "@/features/annotation/lib/useSchedules";
import { useZoneHistoryQuery } from "@/shared/api";
import { ZoneItem } from "./zone-item";

export function Zones() {
  const { activeSchedule } = useSchedules({ queryKey: "zoneHistorySchedules" });

  const { data: zoneHistory } = useZoneHistoryQuery(
    { historyId: activeSchedule?.id as number },
    { skip: !activeSchedule }
  );

  return (
    <>
      {zoneHistory?.results.map((zone) => (
        <ZoneItem zone={zone} key={zone.id} />
      ))}
    </>
  );
}
